var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, alpha, useTheme } from '@mui/material';
import { useCallback, useRef } from 'react';
var dragHeaderSx = function (theme) { return ({
    cursor: 'grab',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.body1.fontSize,
    '&:active': { cursor: 'grabbing' },
}); };
export var useDraggableColumns = function (order, hidden, onUpdate) {
    var theme = useTheme();
    var dropIndicatorBorder = "3px solid ".concat(alpha(theme.palette.common.white, 0.7));
    var orderRef = useRef(order);
    orderRef.current = order;
    var hiddenRef = useRef(hidden);
    hiddenRef.current = hidden;
    var draggingFieldRef = useRef(null);
    var dragOverElementRef = useRef(null);
    var handleDragStart = useCallback(function (e, field) {
        draggingFieldRef.current = field;
        e.dataTransfer.effectAllowed = 'move';
    }, []);
    var handleDragOver = useCallback(function (e) {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        var el = e.currentTarget;
        if (dragOverElementRef.current !== el) {
            if (dragOverElementRef.current)
                dragOverElementRef.current.style.borderLeft = '';
            dragOverElementRef.current = el;
        }
        el.style.borderLeft = dropIndicatorBorder;
    }, [dropIndicatorBorder]);
    var handleDragLeave = useCallback(function (e) {
        e.currentTarget.style.borderLeft = '';
        dragOverElementRef.current = null;
    }, []);
    var handleDrop = useCallback(function (e, targetField) {
        e.preventDefault();
        e.currentTarget.style.borderLeft = '';
        dragOverElementRef.current = null;
        var sourceField = draggingFieldRef.current;
        if (!sourceField || sourceField === targetField)
            return;
        var newOrder = __spreadArray([], orderRef.current, true);
        var fromIdx = newOrder.indexOf(sourceField);
        var toIdx = newOrder.indexOf(targetField);
        if (fromIdx === -1 || toIdx === -1)
            return;
        newOrder.splice(fromIdx, 1);
        newOrder.splice(toIdx, 0, sourceField);
        onUpdate(newOrder, hiddenRef.current);
        draggingFieldRef.current = null;
    }, [onUpdate]);
    var handleDragEnd = useCallback(function () {
        if (dragOverElementRef.current) {
            dragOverElementRef.current.style.borderLeft = '';
            dragOverElementRef.current = null;
        }
        draggingFieldRef.current = null;
    }, []);
    var makeDraggableHeader = useCallback(function (field, content) { return (_jsx(Box, __assign({ component: "div", draggable: true, onDragStart: function (e) { return handleDragStart(e, field); }, onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: function (e) { return handleDrop(e, field); }, onDragEnd: handleDragEnd, sx: dragHeaderSx }, { children: content }))); }, [handleDragStart, handleDragOver, handleDragLeave, handleDrop, handleDragEnd]);
    return { makeDraggableHeader: makeDraggableHeader };
};
